import * as angular from 'angular';

interface EnvironmentJson {
  ENV_TYPE: string;
  API_PATH: string;
  VERSION: string;
  NAME: string;
  HIGHLIGHT: string;
  APP_INSIGHTS_KEY: string;
  EightyToolset: string;
  OneSixtyToolSet: string;
}

export interface Environment {
  ENV_TYPE: string;
  API_PATH: string;
  VERSION: string;
  NAME: string;
  HIGHLIGHT: string;
  APP_INSIGHTS_KEY: string;
  EightyToolset: string;
  OneSixtyToolSet: string;
}

declare let ENVIRONMENT_JSON: string;

let environment: Environment;

let environmentJson: EnvironmentJson = JSON.parse(ENVIRONMENT_JSON);

environment = {
  'ENV_TYPE': environmentJson.ENV_TYPE,
  'API_PATH': environmentJson.API_PATH,
  'VERSION': environmentJson.VERSION,
  'NAME': environmentJson.NAME,
  'HIGHLIGHT': environmentJson.HIGHLIGHT,
  'APP_INSIGHTS_KEY': environmentJson.APP_INSIGHTS_KEY,
  'EightyToolset': environmentJson.EightyToolset,
  'OneSixtyToolSet': environmentJson.OneSixtyToolSet
};

export default angular.module("aps.environment", [])
  .constant("environment", environment)
  .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/shared/config/environment.ts